<template>
  <div id="app">
    
    <router-view/>
	
  </div>
</template>

<script>
export default {
  name: 'Public',
  components: {
   
  },
   methods: {
	  
  },data: function() {
        return {
           
        }
    }
}
</script>